import { getAdminAxiosInstance } from "../../../api/Admin";

export const getTransactionExportedData = async (params) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.post(`/wallet-transaction/report`, params, {
      responseType: "blob",
    });
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};
